import transformKeys from "shared/helpers/transformKeys";

export default [
  {
    component: () => import("shared/pages/OauthLogin.vue"),
    meta: {
      freeAccess: true,
      public: true,
    },
    path: "/oauth",
    props: (route) => ({
      ...route.params,
      ...transformKeys(route.query, "camelCase"),
    }),
  },
  {
    alias: "/login",
    component: () => import("pages/LoginPage.vue"),
    meta: {
      accessLevel: "limited",
      freeAccess: true,
      title: "Login",
    },
    name: "login",
    path: "/sign-in",
    props: (route) => ({
      redirect: route.query.redirect,
    }),
  },
  {
    name: "logout",
    path: "/logout",
    redirect: { name: "login" },
  },
];
